<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">老有所学</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <!-- <div class="health" @click.stop.prevent="goAnHui">
        <div class="module_left">安徽老年远程教育网</div>
        <div class="module_right_icon1 AnHui1">
          <div class="module_right_icon2 AnHui2">
            <div class="module_right_icon3 AnHui3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goHeFei">
        <div class="module_left">合肥终身学习网</div>
        <div class="module_right_icon1 HeFei1">
          <div class="module_right_icon2 HeFei2">
            <div class="module_right_icon3 HeFei3"></div>
          </div>
        </div>
      </div> -->
      <div class="health" @click.stop.prevent="goCountry">
        <div class="module_left">国家老年大学</div>
        <div class="module_right_icon1 LearnShow1">
          <div class="module_right_icon2 LearnShow2">
            <div class="module_right_icon3 country"></div>
          </div>
        </div>
      </div>

      <!-- <div class="health" @click.stop.prevent="goOldStudy">
        <div class="module_left">老有所学</div>
        <div class="module_right_icon1 OldStudy1">
          <div class="module_right_icon2 OldStudy2">
            <div class="module_right_icon3 OldStudy3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goForum">
        <div class="module_left">名师讲坛</div>
        <div class="module_right_icon1 Forum1">
          <div class="module_right_icon2 Forum2">
            <div class="module_right_icon3 Forum3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goCourse">
        <div class="module_left">视频课程</div>
        <div class="module_right_icon1 Course1">
          <div class="module_right_icon2 Course2">
            <div class="module_right_icon3 Course3"></div>
          </div>
        </div>
      </div>


      <div class="health" @click.stop.prevent="goBooks">
        <div class="module_left">数字图书</div>
        <div class="module_right_icon1 Books1">
          <div class="module_right_icon2 Books2">
            <div class="module_right_icon3 Books3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goLearnShow">
        <div class="module_left">我学我秀</div>
        <div class="module_right_icon1 LearnShow1">
          <div class="module_right_icon2 LearnShow2">
            <div class="module_right_icon3 LearnShow3"></div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},

  mounted() {},
  beforeDestroy() {},

  methods: {
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
    async goOldStudy() {
      this.$router.push({
        path: "/study/oldStudy/index",
      });
    },
    async goCourse() {
      this.$router.push({
        path: "/study/HeFei/index",
      });
    },
    async goForum() {
      this.$router.push({
        path: "/study/forum/index",
      });
    },

    async goBooks() {
      this.$router.push({
        path: "/study/books/index",
      });
    },
    async goLearnShow() {
      this.$router.push({
        path: "/study/learnShow/index",
      });
    },
    async goAnHui() {
      this.$router.push({
        path: "/study/AnHui/index",
      });
    },
    async goCountry() {
      this.$router.push({
        path: "/study/country/index",
      });
    },
    async goHeFei() {
      this.$router.push({
        path: "/study/HeFei/index",
      });
    },
  },
};
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(95, 141, 255) 6.107%,
    rgb(144, 181, 252) 39.695%,
    rgb(217, 240, 255) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 30px;
    top: 40px;
    z-index: 0;
    width: 352px;
    height: 260px;
    background: url(@/assets/study/studyIndex/studyIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 30px;

  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 325px;
    padding: 27px 0;
    height: 95px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 180px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
    .AnHui1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AnHui2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AnHui3 {
      background: url("@/assets/study/studyIndex/AnHui.png") no-repeat center;
      background-size: 100% 100%;
    }
    .HeFei1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .HeFei2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .HeFei3 {
      background: url("@/assets/study/studyIndex/HeFei.png") no-repeat center;
      background-size: 100% 100%;
    }
    .country {
      background: url("@/assets/study/studyIndex/country.png") no-repeat center;
      background-size: 100% 100%;
    }
    .OldStudy1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .OldStudy2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .OldStudy3 {
      background: url("@/assets/study/studyIndex/oldStudy.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Course1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Course2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Course3 {
      background: url("@/assets/study/studyIndex/course.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Forum1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Forum2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Forum3 {
      background: url("@/assets/study/studyIndex/forum.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Books1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Books2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Books3 {
      background: url("@/assets/study/studyIndex/books.png") no-repeat center;
      background-size: 100% 100%;
    }
    .LearnShow1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .LearnShow2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .LearnShow3 {
      background: url("@/assets/study/studyIndex/learnShow.png") no-repeat
        center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
